import React from 'react';
import { useHistory } from "react-router-dom";

const LeaveSuccessPage = () => {
  const { goBack } = useHistory();

  return (
    <div className="sub_page app_withdrawal mb_paused_complete">
      <main className="container acc_main">
        <section className="main_contents">
          <div className="wrap">
            {/* 완료 text */}
            <article className="paused_complete_content">
              <div className="text_wrap">
                <h3>
                  회원탈퇴가 완료되었습니다.
                </h3>
                <p className="paused_complete_desc">
                  그동안 AI바로셈 서비스를 이용해 주셔서 감사합니다. <br/> 보다 나은 서비스로 다시 찾아 뵙겠습니다.
                </p>
              </div>
            </article>
          </div>
        </section>
        <article className="bottom_zero_btn_wrap">
          <button
            type="button"
            className="bottom_zero_btn"
            onClick={() => { goBack()}}
          >
            <span>확인</span>
          </button>
        </article>
      </main>
    </div>
  );
};

export default LeaveSuccessPage;